import {startTypeShuffle, toggleModalSketch, countdownTimer, vh, utils} from "../components/utils";
import {gsapContext} from "../components/theme-scripts";

export function templateCoCreationLoggedInit() {

	const section2       = document.querySelector('.section-2');
	const section2Panel0 = document.querySelector('.section-2__panel--0');
	const section2Panel1 = document.querySelector('.section-2__panel--1');
	const section2Panel0Toggle = section2Panel0.querySelector('.circle-toggle');
	const section2Panel1Toggle = section2Panel1.querySelector('.circle-toggle');
	const section4Panel0 = document.querySelector('.section-4__panel--0');

	gsapContext.add(() => {

		let section2Ppanels = gsap.utils.toArray('.section-2__panel');

		/**
		 * Animations for section-2
		 */
		gsap.to(section2Ppanels, {
			ease:          'none',
			scrollTrigger: {
				trigger: section2,
				pin:     true,
				scrub:   0.1,
				end:     () => '+=' + vh(300), // total length of .section2Ppanels
				//markers: true
			}
		});

		/**
		 * Animations for section-2__panel--0
		 */
		ScrollTrigger.create({
			trigger:     section2Panel0,
			start:       () => 'top top',
			end:         () => '+=' + vh(125),
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section2Panel0);
			},
			onLeave:     () => {
				section2Panel0.classList.remove('trigger-2');
			},
			onLeaveBack: () => {
				section2Panel0.classList.remove('trigger-2');
			},
			//markers:     true
		});

		/**
		 * Animations for section-2__panel--1
		 */
		gsap.to(section2Panel1, {
			left:          0,
			ease:          'none',
			scrollTrigger: {
				trigger: section2Panel1,
				start:   () => 'top+=' + vh(100) + ' top',
				end:     () => '+=' + vh(100),
				scrub:   1,
				//markers: {startColor: 'blue', endColor: 'blue', indent: 100}
			}
		});

		ScrollTrigger.create({
			trigger:     section2Panel1,
			start:   () => 'top+=' + vh(200) + ' top',
			end:         () => '+=' + vh(100),
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section2Panel1);
			},
			onLeave:     () => {
				section2Panel1.classList.remove('trigger-2');
			},
			onLeaveBack: () => {
				section2Panel1.classList.remove('trigger-2');
			},
			//markers:     true
		});

		section2Panel0Toggle.addEventListener('click', function () {

			utils.toggleClasses(section2Panel0, 'trigger-1', 'trigger-2');

		});

		section2Panel1Toggle.addEventListener('click', function () {

			utils.toggleClasses(section2Panel1, 'trigger-1', 'trigger-2');

		});


		/**
		 * Animations for section-4__panel--0 elements
		 */
		ScrollTrigger.create({
			trigger:     section4Panel0,
			start:       () => 'top 50%',
			end:         () => 'bottom 50%',
			toggleClass: 'trigger-1',
			onEnter:     () => {
				startTypeShuffle(section4Panel0);
			}
			//markers:     true
		});

	});



	function initCountdowns() {
		let countdowns = document.querySelectorAll('.countdown');

		countdowns.forEach((el) => {
			countdownTimer(el.getAttribute('data-date'), el);
		});
	}


	let vote = function (e) {
		e.preventDefault();

		let choice = e.target.closest('.choice--enabled'); // clicked choice

		if (choice === null)
		{
			return false;
		}

		let votazione = choice.closest('.votazione');

		votazione.classList.add('votazione--in-progress');

		let choiceId = choice.dataset.choiceId;

		const data = new FormData();
		data.append('action', 'oe_vote');
		data.append('choice', choiceId);
		data.append('nonce', ajax_vars.nonce);

		fetch(ajax_vars.ajax_url, {
			method:      'POST',
			credentials: 'same-origin',
			body:        data
		})
			.then((response) => response.json())
			.then((data) => {
				if (data)
				{
					setTimeout(function () {
						getVotazioneCorrenteHtml();
					}, 300);
				}
			})
			.catch((error) => {
				console.error(error);
			});
	};

	let getVotazioneCorrenteHtml = function () {

		let votazione = document.querySelector('.votazione--in-progress');

		const data = new FormData();
		data.append('action', 'wc_do_ajax');
		data.append('fn', 'getVotazioneCorrenteHtmlAjax');
		data.append('nonce', ajax_vars.nonce);

		fetch(ajax_vars.ajax_url, {
			method:      'POST',
			credentials: 'same-origin',
			body:        data
		})
			.then((response) => response.json())
			.then((data) => {
				if (data)
				{
					let votazione       = document.querySelector('.votazione');
					votazione.outerHTML = JSON.parse(data.html);
					votazione.classList.remove('votazione--in-progress');

					initCountdowns();
				}
			})
			.catch((error) => {
				console.error(error);
			});
	};

	document.removeEventListener('click', vote);
	document.addEventListener('click', vote);

	initCountdowns();
}